

import { Amplify } from 'aws-amplify';



// The single source of truth for Amplify configuration. Previously App.js
// ALSO called Amplify.configure() separately (with the legacy flat
// aws-exports.js shape) — Amplify.configure() replaces the whole config on
// every call rather than merging, so whichever call happened to run last
// won outright. Under Vite's ESM import ordering that was this call
// (correct Auth shape), then App.js's legacy-format call overwrote it,
// leaving Auth unconfigured ("UserPool not configured"). Configuring
// everything here, once, removes that race entirely.
export function configureAmplify() {
  Amplify.configure({
    Auth: {
      // Controls what users can sign in with. Adjust to match your User Pool settings.
      loginWith: {
        username: false, // set to true if you use "Username"
        email: true,    // set to true if you allow "Email" sign in
        phone: false
      },
      Cognito: {
        region: 'us-east-1',
        userPoolId: 'us-east-1_G0VobzUMd', //us-east-1_Xt1euVvVY',
        userPoolClientId: '1h0o3j14nquf7m19l41p9k0nv9',//21m9fvrao4imb91l50gdvvbd14'
        identityPoolId: 'us-east-1:53cd420f-6f1e-409a-80fe-f65b803e9fd7',
      }
      // storage: By default Amplify uses @react-native-async-storage/async-storage if available
    },
    Geo: {
      LocationService: {
        region: 'us-east-1',
        searchIndices: {
          items: ['eabuplaceIndex70b49b7c-dev', 'placeIndex43161903-dev'],
          default: 'placeIndex43161903-dev',
        },
        maps: {
          items: { 'mapaf4ee080-dev': { style: 'VectorEsriStreets' } },
          default: 'mapaf4ee080-dev',
        },
      },
    },
    API: {
      endpoints: [{
        name: 'identityAPI',
        endpoint: 'https://api.eabu.net/identity',
        region: 'us-east-1',
      }],
    },
    Storage: {
      AWSS3: {
        bucket: 'eabu-identity-pictures',
        region: 'us-east-1',
      },
    },
  });
}
